import { ajax } from '../../../services/helper'
class ApiService {

    getClustersData = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/clusters/list"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

      getClusterById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/clusters/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }   


    



    updateKitchen = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/kitchens/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }




    removeCusterKitchen = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/clusters/"+id+"/removeKitchen"
            ajax(url,'POST')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    


    addCluster = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/clusters/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


        editCluster = (data,id) => {
            return new Promise((resolve, reject) => {
                const url = "/v1/clusters/"+id+"/update"
                ajax(url,'POST', data)
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            })
        }
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Clusters/services/apiservices.js